import { render, staticRenderFns } from "./GoodPlatform.vue?vue&type=template&id=2f29088f&"
import script from "./GoodPlatform.vue?vue&type=script&lang=js&"
export * from "./GoodPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports